import { createAsyncThunk } from "@reduxjs/toolkit";
import { getMagicPotList, getMagicPotListByPage,getMagicPotDonationList,getMagicPotDonationListByPage } from "../../helper/BackendHelper";

export const MagicPotsInitialLoad = createAsyncThunk(
    "magicpot/initial",
    async (data, thunkAPI) => {
        const response = await getMagicPotList();
        if (response?.status === 500) {
            return thunkAPI.rejectWithValue("Server Error");
        } else {
            return response?.data;
        }
    }
);

export const MagicpotPaggination = createAsyncThunk(
    "magicpot/paggination",
    async (data, thunkAPI) => {
        const response = await getMagicPotListByPage(data);
        if (response?.status === 500) {
            return thunkAPI.rejectWithValue("Server Error");
        } else {
            return response?.data;
        }
    }
);

export const MagicPotsDonationList = createAsyncThunk(
    "magicpot/magicpotlist",
    async (data, thunkAPI) => {
        const response = await getMagicPotDonationList();
        if (response?.status === 500) {
            return thunkAPI.rejectWithValue("Server Error");
        } else {
            return response?.data;
        }
    }
);

export const MagicPotsDonationListByPage = createAsyncThunk(
    "magicpot/magicpotlistbypage",
    async (data, thunkAPI) => {
        const response = await getMagicPotDonationListByPage(data);
        if (response?.status === 500) {
            return thunkAPI.rejectWithValue("Server Error");
        } else {
            return response?.data;
        }
    }
);
